import api from './client';

// kind: 'items' | 'cables' — both return the record's updated photos array
export const uploadPhotos = (kind, id, files) => {
  const form = new FormData();
  files.forEach(f => form.append('photos', f));
  return api.post(`/${kind}/${id}/photos`, form);
};
export const deletePhoto = (kind, id, photoId) => api.delete(`/${kind}/${id}/photos/${photoId}`);
